import React, { useState, useEffect } from "react";

import { useNavigate, Link, useLocation, useOutletContext } from "react-router-dom";
import { UiSelect, UiDatePicker, UiRSelect, TableZero, BgLoader, UiButton } from "../../ui.js";
import Accordion from 'react-bootstrap/Accordion';
import { toast } from "react-toastify";
import { instance } from "../../axios";
import { set } from "date-fns";
import { MdOutlineFactory, MdWaterDrop, MdLocalHotel, MdLocalTaxi } from "react-icons/md";
import { FaMountainSun, FaTruckMoving, FaWarehouse, FaBottleWater, FaMountain } from "react-icons/fa6";
import { FaCog, FaTools, FaPowerOff, FaSolarPanel, FaCalculator, FaPhoneAlt } from "react-icons/fa";
import { GiPizzaCutter, GiCircularSaw, GiCargoCrane } from "react-icons/gi";
import { BsBank } from "react-icons/bs";



export default function Home() {
  const { setTitle } = useOutletContext();
  const [state, setState] = useState({});
  const navigate = useNavigate();
  const fetchData = () => {
    instance
      .get("/main_screen.php?list_categories=1")
      .then(function (response) {
        setState({ ...state, ...response.data });
        if (response.data.status == 'success') {

        } else {
          toast(response.data.msg, { type: "error" });
        }

      })
      .catch(function (error) { })
      .then(function () { });

  }







  useEffect(() => {
    setTitle(null)
    fetchData();


  }, []);
  return (
    <div className="mt-3">
      <b>Main Categories</b>
      <div className="row g-1 mb-3">
        <div className="col-3">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Stones'); }}>
            <MdOutlineFactory size={34} className="text-secondary" />
            <span className="d-block">Stones</span>
          </div>
        </div>
        <div className="col-3">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Mining'); }}>
            <FaMountainSun size={34} className="text-secondary" />
            <span className="d-block">Mining</span>
          </div>
        </div>
        <div className="col-3">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Transport'); }}>
            <FaTruckMoving size={34} className="text-secondary" />
            <span className="d-block">Transport</span>
          </div>
        </div>
        <div className="col-3">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Godown'); }}>
            <FaWarehouse size={34} className="text-secondary" />
            <span className="d-block">Godown</span>
          </div>
        </div>
      </div>

 <b>Support Services</b>
      <div className="row g-1 mb-3 row-cols-5">
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Machine+Manufacturer'); }}>
            <FaCog size={25} className="text-secondary" />
            <span className="d-block small">Machine Manufacturer</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Machine+Repairing'); }}>
            <FaTools size={25} className="text-secondary" />
            <span className="d-block small">Machine Repairing</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Brazing+Service'); }}>
            <GiPizzaCutter size={25} className="text-secondary" />
            <span className="d-block small">Brazing Service</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Blades+%26+Segments'); }}>
            <GiCircularSaw size={25} className="text-secondary" />
            <span className="d-block small">Blades & Segments</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Abrasives+%26+Epoxy+Traders'); }}>
            <FaBottleWater size={25} className="text-secondary" />
            <span className="d-block small">Abrasives & Epoxy Traders</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Machinery+Parts'); }}>
            <FaCog size={25} className="text-secondary" />
            <span className="d-block small">Machinery Parts</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Mining+Equipment'); }}>
            <GiCargoCrane size={25} className="text-secondary" />
            <span className="d-block small">Mining Equipment</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Electric+Panel+%26+Repairing'); }}>
            <FaPowerOff size={25} className="text-secondary" />
            <span className="d-block small">Electric Panel & Repairing</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Powder+Supplier'); }}>
            <FaMountain size={25} className="text-secondary" />
            <span className="d-block small">Powder Supplier</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Solar+Plant+Services'); }}>
            <FaSolarPanel size={25} className="text-secondary" />
            <span className="d-block small">Solar Plant Services</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Water+Supplier'); }}>
            <MdWaterDrop size={25} className="text-secondary" />
            <span className="d-block small">Water Supplier</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Hotel+%26+Restaurant'); }}>
            <MdLocalHotel size={25} className="text-secondary" />
            <span className="d-block small">Hotel & Restaurant</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Local+Taxi+Service'); }}>
            <MdLocalTaxi size={25} className="text-secondary" />
            <span className="d-block small">Local Taxi Service</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/CA+%26+Tax+Advisor'); }}>
            <FaCalculator size={25} className="text-secondary" />
            <span className="d-block small">CA & Tax Advisor</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Banking+%26+Loan+Services'); }}>
            <BsBank size={25} className="text-secondary" />
            <span className="d-block small">Banking & Loan Services</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-white rounded px-3 py-2 border text-center cursor-pointer" onClick={() => { navigate('/category/Others/Important+Contact+Numbers'); }}>
            <FaPhoneAlt size={25} className="text-secondary" />
            <span className="d-block small">Important Contact Numbers</span>
          </div>
        </div>
    
      </div>


      {state.category && state.category.map((item, index) => {
        return <button
          key={item.label}
          className="btn btn-outline-secondary text-dark w-100 mb-2"
          onClick={() => { navigate(item.link); }}
        >
          {item.label}
        </button>
      })}
      <button
        className="btn btn-outline-secondary text-dark w-100 mb-2"
        onClick={() => { navigate('/add-your-business'); }}
      >
        Add Your Business
      </button>
    </div>
  );
}
